import { Injectable } from '@angular/core';
import { blockUi } from '@bndes/bndes-ux4/bndes-angular-utils';
import { catchError, Observable } from 'rxjs';
import { DetalheDistribuicaoLimiteAgenteDto } from 'src/app/model/detalhe-distribuicao-limite-agente-dto.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';

@Injectable({
  providedIn: 'root'
})
export class DistribuicaoLimiteAgentesService extends FgiBackEndService<DetalheDistribuicaoLimiteAgenteDto>{
  
  getNewEntity() {
    return new DetalheDistribuicaoLimiteAgenteDto();
  }

  protected getResourceURL(): string {
    return 'front/distribuicao-limites';
  }

  public buscarAgentes(idCiclo: number, params: any): Observable<ResultadoPaginado<DetalheDistribuicaoLimiteAgenteDto>> {
    const options: object = blockUi({ params });
    return this.http.get<ResultadoPaginado<DetalheDistribuicaoLimiteAgenteDto>>(`${this.BASE_URL}/${idCiclo}/agentes`, options).pipe
      (catchError((e) => this.handleError(e)));
  }

  public buscarAgentePorCicloModalidade(idCiclo: number, idAgenteModalidade: number): Observable<DetalheDistribuicaoLimiteAgenteDto> {
    const options: object = blockUi();
    return this.http.get<DetalheDistribuicaoLimiteAgenteDto>(`${this.BASE_URL}/${idCiclo}/agente/${idAgenteModalidade}`, options).pipe
      (catchError((e) => this.handleError(e)));
  }
}
